import React from "react";
import { Container, Row, Form, Button } from "react-bootstrap";

import studentsService from "presentation/services/students";
import addressesService from "presentation/services/addresses";
import phonesService from "presentation/services/phones";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import StudentForm from 'presentation/pages/students/elements/form';

import { handleChange, getGender, getDocumentFieldType, dateIsInvalid } from "presentation/utils/functions/generic";

import {
  mountItems
} from 'presentation/pages/persons/functions/phones';

import moment from "moment";


class StudentAdd extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      actionLoading: false,
      error: false,
      message: '',
      data: [],
      phones: [],
      totalPhoneItems: 1,
    };
  }

  async componentDidMount() {
    await this.loadData();
    mountItems(this);
  }

  loadData = async () => {
    const { location } = this.props;

    const { newRegistration, personName, personId, personEntity } = location.state || {};

    let form = {};

    if (personId && personEntity) {

      var genderInfo = personEntity.gender ? getGender(personEntity.gender.toString().toLowerCase()) : undefined;
      var genderId = typeof (genderInfo) === 'undefined' ? -1 : genderInfo.id;


      var documentFieldTypeInfo = personEntity.documentFieldType ? getDocumentFieldType(personEntity.documentFieldType.toString().toLowerCase()) : undefined;
      var documentFieldTypeId = typeof (documentFieldTypeInfo) === 'undefined' ? -1 : documentFieldTypeInfo.id;

      if (!dateIsInvalid(personEntity.naturalPerson?.birthdate)) {
        form.birthdate = moment(personEntity.naturalPerson?.birthdate, 'YYYY-MM-DD').format("YYYY-MM-DD");
      }


      form.personId = personId;
      form.userId = personEntity.userId;
      form.name = personEntity.name;
      form.displayName = personEntity.displayName;
      form.genderId = genderId;
      form.documentField = personEntity.documentField;
      form.documentFieldType = documentFieldTypeId;


    } else {
      if (newRegistration && personName) {
        form.name = personName;
        form.displayName = personName;
      }
    }

    this.setState({ form: form, loading: false });
  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  handleSubmit = async () => {

    this.setState({ loading: true, actionLoading: true, error: '' });

    const {
      name,
    } = this.state.form;

    if (!name) {
      this.setState({ loading: false, error: true, message: "Por favor, preencha um nome..." });
    } else {
      let postData = this.state.form;
      let addressData = this.state.addressForm || [];
      let phones = this.state.phones || [];

      if (dateIsInvalid(postData.birthdate)) {
        postData.birthdate = null;
      }

      if (dateIsInvalid(postData.registrationDate)) {
        postData.registrationDate = null;
      }

      postData.registration = "" + postData.registration;

      try {
        const response = await studentsService.add(postData);
        if (response.error == true) {
          this.setState({
            loading: false,
            actionLoading: false,
            error: true,
            message: response.message
          });
        } else {
          addressData.personId = response.personId;
          const addressResponse = await addressesService.save(addressData);
          if (addressResponse.error == true) {
            //TODO - notify
          }

          let phonesData = phones.map((e, i) => {
            e.personId = response.personId;
            return e;
          });
          
          const phonesResponse = await phonesService.batchManagement(phonesData);
          
          if (phonesResponse.error == true) {
            //TODO - notify
          }
          this.goTo("/alunos");
        }
      } catch (err) {
        this.setState({
          loading: false,
          actionLoading: false,
          error: true,
          message: err.message
        });
      }
    }
  };

  render() {
    let { location } = this.props;
    let { loading, error, message, actionLoading, form, addressForm, phones } = this.state;
    let { handleSubmit } = this;


    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <StudentForm
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                loading={loading}
                form={form}
                addressForm={addressForm}
                phones={phones}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default StudentAdd;
